import { Link } from "react-router-dom";
import type { ActionItem } from "@/lib/types";
import { formatEuro } from "@/lib/format";

export default function ActionCard({ action }: { action: ActionItem }) {
  const goal = Number(action.cagnotte_goal || 0);
  const collected = Number(action.cagnotte_collected || 0);
  const pct = goal > 0 ? Math.min(100, Math.round((collected / goal) * 100)) : 0;
  const hasCagnotte = goal > 0;

  return (
    <article className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
      <Link
        to={`/actions/${action.slug}`}
        className="block w-full aspect-[16/10] overflow-hidden cursor-pointer"
      >
        <img
          src={action.gallery[0]}
          alt={action.title}
          title={`${action.title} — Humanity59`}
          className="w-full h-full object-cover object-top"
        />
      </Link>

      <div className="p-6 md:p-7">
        <div className="flex items-start justify-between gap-4">
          <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className={`${action.icon} text-xl`}></i>
          </span>
          <div className="text-right">
            <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">
              {action.stat.value}
            </p>
            <p className="text-xs text-foreground-500">{action.stat.label}</p>
          </div>
        </div>

        <Link to={`/actions/${action.slug}`} className="cursor-pointer">
          <h2 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950 hover:text-primary-600 transition-colors">
            {action.title}
          </h2>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 min-h-[4.25rem]">
          {action.description}
        </p>

        {hasCagnotte && (
          <div className="mt-5">
            <div className="flex items-center justify-between text-sm">
              <span className="font-semibold text-primary-600">
                {formatEuro(collected)} collectés
              </span>
              <span className="font-heading font-bold text-foreground-950">
                {pct}%
              </span>
            </div>
            <div className="mt-2 h-2.5 rounded-full bg-background-200 overflow-hidden">
              <div
                className="h-full rounded-full bg-primary-500 transition-all duration-500"
                style={{ width: `${pct}%` }}
              />
            </div>
            <p className="mt-1.5 text-xs text-foreground-500">
              Objectif : {formatEuro(goal)}
            </p>
          </div>
        )}

        <div className="mt-5 flex flex-wrap items-center gap-3">
          <Link
            to={`/actions/${action.slug}`}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 text-foreground-700 hover:bg-background-100 px-5 py-2.5 text-sm font-semibold transition-all duration-200 cursor-pointer"
          >
            En savoir plus
            <i className="ri-arrow-right-line"></i>
          </Link>

          {hasCagnotte && (
            <Link
              to={`/actions/${action.slug}#don`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 px-5 py-2.5 text-sm font-semibold transition-all duration-200 cursor-pointer"
            >
              <i className="ri-hand-heart-line"></i>
              Soutenir
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}